module.exports = __webpack_public_path__ + "img/play-button.bfce4bee.png";